import { Typography } from "@mui/material";
import NumberFormats from "components/NumberFormats";

function Total({ data }) {
  return (
    <Typography variant="h6" color="text.main" pl={1}>
      <NumberFormats value={data?.total} /> {data?.nameCoin}
    </Typography>
  );
}

export default Total;
